import { GROUP_ROLES as g_roles } from 'constants';

export const PATICIPANTS = () => 'مشارك';
export const CANCEL_ACTION_SHEET = 'إلغاء';
export const CREATE_PM_CONV = 'إرسال رسالة خاصة';
export const MAKE_ADMIN = 'تعيين آدمن';
export const UNMAKE_ADMIN = 'عزل آدمن';
export const REMOVE_MEMBER = 'ازالة من المجموعة';
export const VIEW = 'عرض';
export const DOWNLOAD = 'تحميل';
export const DELETE = 'حذف';
export const EDIT = 'تعديل';
export const SUBMIT = 'رفع التسليم';
export const NO_TASK_ADMIN = 'انقر اضافة تكليف لاضافة تكليف جديدة';
export const NO_TASK_MEMBER = 'لم يتم اضافة تكليف بعد';
export const NO_MATERIAL_ADMIN = 'انقر رفع ملفات لاضافة منهج جديد';
export const NO_MATERIAL_MEMBER = 'لم يتم رفع منهج بعد';
export const MUTE = 'كتم';
export const GALLERY = 'الصور، الفيديوهات والروابط';
export const LEAVE_GROUP = 'مغادرة المجموعة';
export const BLOCKED_MEMBERS = 'قائمة الحظر';
export const ADD_PARTICIPANT = 'اضافة عضو';
export const JOIN_CLOSED = 'الانضمام مغلق';
export const JOIN_OPENED = 'الانضمام مفتوح';
export const EDIT_GROUP_INFO = 'تعديل معلومات المجموعة';
export const INV_CODE = 'رمز الدعوة';
export const JOIN_CLOSE_MSG = `تم اغلاق الانضمام من قبل الادمن`;
export const SUBMIT_MSG = title => `تم تسليم ${title}`;
export const SUBMISSION_COUNTER = (counter, total) => `سلم ${counter} من أصل ${total} أعضاء`;
export const GROUPS_IN_COMMON = 'المجموعات المشتركة';
export const BLOCK_MEMBER = 'حجب و إبلاغ';

export const GROUP_ROLES = {
    [g_roles.ADMIN]: 'آدمن',
    [g_roles.MEMBER]: 'عضو',
    [g_roles.CREATOR]: 'منشئ المجموعة'
};

export const TASK_TYPES = {
    GENERAL: 'عام',
    HOMEWORK: ' واجب منزلي',
    MAJOR_EXAM: 'اختبار شهري',
    MID_TERM: 'اختبار منتصف الفصل',
    FINAL_EXAM: 'اختبار نهائي',
    QUIZ: 'اختبار قصير',
    PROJECT: 'مشروع',
    PRESENTATION: 'عرض تقديمي'
};



// WEBPACK FOOTER //
// ./src/lang/ar/right.js